<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="item in tabMapOptions"
        :key="item.key"
        :label="item.label"
        :name="item.key"
      >
        <!-- <keep-alive> -->
        <component
          :is="activeName"
          :contractNo="contractNo"
          v-if="activeName === item.key"
          :ref="item.key"
        />
        <!-- </keep-alive> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Trade from './components/Trade/index.vue';
  import MultimodalTransport from './components/MultimodalTransport/index.vue';
  import ParkWarehouse from './components/ParkWarehouse/index.vue';
  import ParkProperty from './components/ParkProperty/index.vue';
  import SuperviseContract from './components/SuperviseContract/index.vue';
  import TradeCK from './components/ChengKuangTrad/index.vue';
  export default {
    name: 'receivables',
    components: {
      Trade,
      MultimodalTransport,
      ParkWarehouse,
      ParkProperty,
      SuperviseContract,
      TradeCK,
    },
    data() {
      return {
        activeName: 'Trade',
        contractNo: '',
        tabMapOptions: [
          { label: '贸易', key: 'Trade' },
          { label: '多式联运', key: 'MultimodalTransport' },
          { label: '园区仓储', key: 'ParkWarehouse' },
          { label: '园区物业', key: 'ParkProperty' },
          { label: '监管单', key: 'SuperviseContract' },
          { label: '城矿', key: 'TradeCK' },
        ],
      };
    },
    mounted() {
      if (this.$route?.query.status == 'leaseContract') {
        console.log('接受参数', this.$route?.query);
        this.activeName = 'ParkProperty';
        this.contractNo = this.$route?.query.contractNo;
      }
      this.$nextTick(() => {
        if (
          [
            '供应链运输事业部',
            '广西物产桂储物流有限公司',
            '广西物产供应链管理有限公司',
            '柳州市桂中海迅运输有限公司',
            '广西桂物通物流有限公司',
            '广西物产桂储物流有限公司成都分公司',
            '广西物产桂储物流有限公司天津分公司',
          ].includes(this.userInfo.companyName)
        ) {
          this.activeName = 'MultimodalTransport';
        } else if (this.userInfo.businessGroup == '城矿') {
          this.activeName = 'TradeCK';
        } else {
          this.activeName = 'Trade';
        }
      });
    },
    watch: {
      $route: {
        handler: function (newValue) {
          if (newValue && newValue.query && newValue.query.contractNo) {
            setTimeout(() => {
              this.activeName = 'ParkProperty';
            }, 20);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-tabs__header {
      margin: 0px !important;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      border-bottom: none;
      background: #fff;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      background: #ebf3fe;
      border-bottom: 1px solid #e4e7ed;
    }
  }
</style>
